// Invoice status pill labels (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'invoice_status.draft': 'Draft',
  'invoice_status.issued': 'Issued',
  'invoice_status.paid': 'Paid',
  'invoice_status.void': 'Void',
  'invoice_status.overdue': 'Overdue',
}

export const zhTW = {
  'invoice_status.draft': '草稿',
  'invoice_status.issued': '已開立',
  'invoice_status.paid': '已付款',
  'invoice_status.void': '作廢',
  'invoice_status.overdue': '逾期',
}
